import { getAppViewMode } from "shared/components/App/Auth"


const hasViewMode = (roles : String[]) : boolean => {

    const viewMode : String = getAppViewMode()

    return roles.includes(viewMode)
}

export default hasViewMode